import React from 'react';
import ChartView from "../../../_common/components/ChartView";

export const Chart = ({
                        header = '',
                        options,
                        type,
                        width,
                        height,
                        containerClassNames
                      }) => {

  return (
    <ChartView
      options={options}
      series={options.series}
      type={type}
      width={width}
      height={height}
      containerClassNames={containerClassNames}
      header={header}
    />
  )
}
